import {Injectable} from '@angular/core';
import {NbComponentStatus, NbGlobalPosition, NbToastRef, NbToastrService} from '@nebular/theme';
import {ChatManagerService} from './chatManager.service';

@Injectable({
  providedIn: 'root',
})
export class ToastrService {
  private loadingToastRef?: NbToastRef;

  constructor(private toastrService: NbToastrService,
              private chatService: ChatManagerService,
  ) {
  }

  showToast(message: string, title: string, status: NbComponentStatus, position: NbGlobalPosition, openChat: boolean = false): void {
    if (status === 'danger') {
      this.toastrService.show(message, title, {status: status, position: position, duration: 20000});
      if (openChat) {
        this.chatService.openChat();
      }
    } else {
      this.toastrService.show(message, title, {status: status, position: position, duration: 5000});
    }
  }

  showLoadingToast(message: string, title: string, position: NbGlobalPosition): void {
    if (this.loadingToastRef) return;

    this.loadingToastRef = this.toastrService.show(
      message,
      title,
      {
        position,
        status: 'info',
        duration: 0,
        icon: 'loader-outline',
      },
    );
  }

  hideLoadingToast(): void {
    if (this.loadingToastRef) {
      this.loadingToastRef.close();
      this.loadingToastRef = undefined;
    }
  }
}
